import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { AddAssesment } from "./AddAssesment";
import { Comments } from "./comments";
import { AssessmentAccordion } from "./AssessmentAccordion";
import { RatingDetails } from "./RatingDetails";
import { AuthContext } from "../../context/AuthContext";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { toast } from "react-toastify";

export const Assessment = () => {
  let { id } = useParams();
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const [assessmentDetails, setAssessmentDetails] = useState([]);  
  const [candidateDetails, setCandidateDetails] = useState([]);     
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [isAssesmentVisible, setIsAssesmentVisible] = useState(false);
  const [accordionData, setAccordionData] = useState([]);
  const { setReloadDataFunc } = useContext(AuthContext);
  const showAssesmentPopup = () => {
    setIsAssesmentVisible(true);
}
const hideAssesmentPopup = () => {
    setIsAssesmentVisible(false)    
}
const fetchDetails = async () => {
  try {
    if (!id){
      id=candidateIdValue;
    }
    const response = await candidateApi.getJobsByCandidate(id);
    console.log("API Response:", response?.data); 
    if (response?.data?.length > 0) {
      setCandidateDetails(response.data);
      // setSelectedJobId(response.data[0].jobId);  
      const maxJob = response.data.reduce((max, job) =>
        job.jobId > max.jobId ? job : max
      );
      setSelectedJobId(maxJob.jobId);
    } 
  } catch (error) {
    toast.error("Error fetching candidate job details", {
              position: "top-right", 
              autoClose: 2000,
      });
    console.error("Error fetching candidate job details:", error);
  }
};
useEffect(() => {
fetchDetails();
}, [id]);
const loadDetails = async () => {
  try {
    if (!id){
      id=candidateIdValue;
    }
    const jobId = selectedJobId;  
    const response = await candidateApi.fetchAssessmentWithRatings(id, jobId);
    console.log("API Response:", response?.data); 
    const assessments = response?.data?.assessment ? Object.values(response.data.assessment) : [];
    const ratings = response?.data?.ratings ? Object.values(response.data.ratings) : [];
    if (assessments.length > 0) {
      console.log("Assessment Data Found", assessments);
      const transformedData = assessments.map((item) => {
        const assessmentRatings = ratings.filter(rating => rating.assessmentId === item.assessmentId);
        return {
          phase: item.phaseValue || "Unknown Phase",
          conductedby: `${item.firstName} ${item.lastName}`.trim() || "N/A",
          actionTaken: item.outcomeValue || "Pending",
          notes: item.remarks || "No notes available",
          assessmentDate: item.assessmentDate ? new Date(item.assessmentDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "N/A",
          ratings: assessmentRatings,
        };
      });
      setAccordionData(transformedData);
    } else {
      
      console.log("No assessments found.");
    }
  } catch (error) {
    toast.error("Error fetching assessment rating data", {
              position: "top-right", 
              autoClose: 2000,
            });
    console.error("Error fetching assessment details:", error);
  }
}; 
useEffect(() => {
  setReloadDataFunc(() => loadDetails); // ✅ Store `loadDetails` in context
  loadDetails(); // ✅ Load details initially
}, [id, selectedJobId]);
  return (
    <section>
      <div className="d-flex gap-3 align-items-center mb-3">
        <h5>
        Assessment
        </h5>
        <button type="submit" className="btn btn-primary ms-auto" onClick={showAssesmentPopup}>
                Add Assessment
                </button>
      </div>
      <div className="row">
      <div className="col-12 col-md-8 left-deck">
        <div className="rating-details mb-4">
          <RatingDetails loadDetail={loadDetails}/>
        </div>
        <div className="Accordion-details">
          <AssessmentAccordion loadDetail={loadDetails}/>
        </div>
      </div>
        <div className="col-12 col-md-4">
            <Comments />
        </div>
      </div>
        {isAssesmentVisible && <AddAssesment closePopup={hideAssesmentPopup} jobId={selectedJobId} reloadData={loadDetails} />}      
    </section>
  );
}

